<ui-card name="Organization Members">
  <ui-data-table (request)="onRequest($event)" [columns]="columns" [response]="response"></ui-data-table>
</ui-card>
